import classnames from 'classnames';

import classNames from 'classnames';
import type { CSSProperties } from 'react';
import type { PostHeaderElementProps } from './PostHeader.types';
import { Serializer } from './serializer';

export function PostHeaderElement(props: PostHeaderElementProps) {
  const { element, children, attributes, className, isLive, utmParams } = props;

  const { mobile_hide, desktop_hide, customAttributes, margin, padding, data, gap, mobileGap, structureTiptapState } =
    element.attrs || {};
  const { post, breadcrumbs, shareUrl } = data || {};

  return (
    <div
      {...customAttributes}
      className={classNames('relative flex flex-col post-header-root-element', !isLive && 'pointer-events-none')}
      style={
        {
          width: '100%',
          margin,
          padding,
        } as CSSProperties
      }
      {...attributes}
    >
      <div
        className={classnames(
          className,
          {
            'mobile:hidden': mobile_hide,
            'desktop:hidden': desktop_hide,
          },
          customAttributes?.className,
          'flex relative',
        )}
        style={
          {
            '--gap': gap,
            '--mobile-gap': mobileGap !== undefined ? mobileGap : gap,
            width: '100%',
            margin,
            padding,
          } as CSSProperties
        }
      >
        <Serializer
          key={post.id}
          node={structureTiptapState?.content?.[0] as any}
          rootClassName={''}
          rootStyle={{}}
          post={post}
          breadcrumbs={breadcrumbs}
          isLive={isLive}
          utmParams={utmParams}
          shareUrl={shareUrl}
        />
      </div>

      {children}
    </div>
  );
}
